import $ from 'jquery'
import create from './create'

export default function() {
    if(typeof $.fn.dataTable !== 'function') return;

    $(this).find("[data-table]").each(function(){ return create(this); });
}


// WEBPACK FOOTER //
// ./node_modules/linksoft-datatables/src/initializer.js